module.exports = __webpack_public_path__ + "media/app/img/unboxing-a0642f1ec2db98ee33a8489c50a41134.png";